import { render, staticRenderFns } from "./Restic.vue?vue&type=template&id=b9e2f51c&scoped=true&"
import script from "./Restic.vue?vue&type=script&lang=js&"
export * from "./Restic.vue?vue&type=script&lang=js&"
import style0 from "./Restic.vue?vue&type=style&index=0&id=b9e2f51c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.6_fb85a9817f99bdf862e5e3a442a1fb91/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9e2f51c",
  null
  
)

export default component.exports